
type ExtractCheckoutDataParams = {
    receiptDetails?: CashBoxOrderItemData | null;
    checkoutId?: CashBoxId | null;
};

type ExtractCheckoutDataErrorCode =
    | "missing_receipt_details"
    | "missing_checkouts"
    | "missing_paid_checkout"
    | "missing_target_checkout";

interface CashBoxCheckoutData {
    orderId: number;
    checkoutDetails: CashBoxCheckout;
    checkoutItems: CashBoxOrderItem[];
    checkoutCustomItems: CashBoxCustomOrderItem[];
    checkoutManualItems: CashBoxManualOrderItem[];
    checkoutDeliveryItem: CashBoxDeliveryDetails | null;
};

type ExtractCheckoutDataResult = {
    data: CashBoxCheckoutData | null;
    errorCode: ExtractCheckoutDataErrorCode | null;
};


const filterEdiblesByCheckoutId = <T extends { checkout_id?: CashBoxId | null }>(
    itemsList: T[],
    targetCheckoutId?: number
): T[] => (
    Array.isArray(itemsList) && targetCheckoutId
        ? itemsList.filter(item => item.checkout_id === targetCheckoutId)
        : []
);

export const extractTargetOrLastCheckout = ({
    receiptDetails,
    checkoutId,
}: ExtractCheckoutDataParams): ExtractCheckoutDataResult => {
    if (!receiptDetails) {
        return {
            data: null,
            errorCode: "missing_receipt_details",
        };
    }

    if (!("checkouts" in receiptDetails) || !receiptDetails?.checkouts) {
        return {
            data: null,
            errorCode: "missing_checkouts",
        };
    }

    const checkouts = receiptDetails.checkouts;

    if (!checkouts.length && checkoutId == null) {
        return {
            data: null,
            errorCode: "missing_paid_checkout",
        };
    }

    // const paidCheckouts = checkouts.filter((item) => item.payment_status === "paid");
    // if (!paidCheckouts.length && checkoutId == null) {
    //     return {
    //         data: null,
    //         errorCode: "missing_paid_checkout",
    //     };
    // }

    let targetCheckout: CashBoxCheckout | null;

    if (checkoutId != null) {
        targetCheckout = checkouts.find(item => item.checkout_id === checkoutId) || null
    } else {
        // // const lastPaidCheckout = paidCheckouts[paidCheckouts.length - 1];
        // const lastPaidCheckout = !paidCheckouts.length
        //     ? null
        //     : paidCheckouts.reduce((a, b) => (
        //         new Date((a as CashBoxCheckout).updated_at).getTime() > new Date(b.updated_at).getTime() ? a : b
        //     ));
        // targetCheckout = lastPaidCheckout || null;

        // Find in all checkout items even if it's payment status is not equal to 'paid' (this status for 'pos' payments is 'suspended' at first)
        const lastCheckout = !checkouts.length
            ? null
            : checkouts.reduce((a, b) => (
                new Date((a as CashBoxCheckout).updated_at).getTime() > new Date(b.updated_at).getTime() ? a : b
            ));
        targetCheckout = lastCheckout || null;
    }

    const targetCheckoutId = targetCheckout?.checkout_id;

    if (!targetCheckout) {
        return {
            data: null,
            errorCode: "missing_target_checkout",
        };
    }

    return {
        data: {
            orderId: receiptDetails.id,
            checkoutDetails: targetCheckout,
            checkoutItems: filterEdiblesByCheckoutId(receiptDetails.items, targetCheckoutId),
            checkoutCustomItems: filterEdiblesByCheckoutId(receiptDetails.customItems, targetCheckoutId),
            checkoutManualItems: filterEdiblesByCheckoutId(receiptDetails.freeItems, targetCheckoutId),
            checkoutDeliveryItem: (
                receiptDetails.delivery &&
                receiptDetails.delivery.checkout_id === targetCheckoutId
            )
                ? receiptDetails.delivery
                : null,
        },
        errorCode: null,
    };
};
